{
  "actions": "Ενέργειες"
}
